/*
 * Opens a URL in a new tab without giving that page `window.opener`, so it
 * cannot redirect the Youro tab behind it (reverse tabnabbing). Unlike the
 * "noopener" feature string, this still returns the window, which callers use
 * to notice when a meeting tab is closed. Returns null if pop-ups are blocked.
 */
export function openInNewTab(url) {
  const win = window.open(url, "_blank");
  if (win) win.opener = null;
  return win;
}
